import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/injectable/auth/auth.service";
import { AdminService } from "src/app/injectable/admin.service";
import { Sender } from "src/app/model/sender";
import { VERSION } from "src/environments/version";
import { DeleteClientComponent } from "./delete-client/delete-client.component";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { InsertClientComponent } from "./insert-client/insert-client.component";
import { InsertClientLogoComponent } from "./insert-client-logo/insert-client-logo.component";
import { EditLogoDialogComponent } from "../client-detail/edit-logo-dialog/edit-logo-dialog.component";
import { SenderInsertRequest } from "./sender-insert-request";
import { Pageable2 } from "src/app/model/pageable2";
import { PaginatorConfig } from "src/app/model/paginatorConfig";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-show-clients",
  templateUrl: "./show-clients.component.html",
  styleUrls: ["./show-clients.component.scss"],
})
export class ShowClientsComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("paginator") paginator: MatPaginator;
  user: string;
  version = VERSION.version;
  sub = false;
  loading = false;
  emptyList = false;
  displayedColumns = ["status", "name", "email", "contractEndDate", "actions"];
  dataSource: MatTableDataSource<Sender>;
  pageable: Pageable2 = new Pageable2();
  paginatorConfig: PaginatorConfig;
  filterValue = "";
  totalElements: number;

  constructor(
    private authService: AuthService,
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {
    this.paginatorConfig = new PaginatorConfig();
    if (sessionStorage.getItem("clientSort") != null) {
      let tmpfilterconfig = JSON.parse(sessionStorage.getItem("clientSort"));
      this.paginatorConfig.setFilterColumn(tmpfilterconfig["active"]);
      this.paginatorConfig.setFilterDirection(tmpfilterconfig["direction"]);
    } else {
      this.paginatorConfig.setFilterColumn("name");
      this.paginatorConfig.setFilterDirection("asc");
    }
    this.pageable = {
      pageable: {
        pageNum: this.paginatorConfig.getPageNum(),
        pageSize: this.paginatorConfig.getPageSize(),
      },
      sort: {
        column: this.paginatorConfig.getFilterColumn(),
        direction: this.paginatorConfig.getFilterDirection(),
      },
      filter: {
        columns: ["name", "email"],
        value: "",
      },
    };
    if (sessionStorage.getItem("latestFilterValueClients") != null) {
      this.filterValue = sessionStorage.getItem("latestFilterValueClients");
      this.pageable.filter.value = this.filterValue;
    }
    if (sessionStorage.getItem("latestPageClients") != null) {
      try {
        this.pageable.pageable.pageNum = Number(
          sessionStorage.getItem("latestPageClients")
        );
      } catch (e) {}
    }
    this.getSenders();
  }

  onPagination(event: PageEvent) {
    this.pageable.pageable = {
      pageNum: event.pageIndex,
      pageSize: event.pageSize,
    };
    sessionStorage.setItem("latestPageClients", event.pageIndex.toString());
    this.getSenders();
  }

  onSortChange(sort) {
    sessionStorage.setItem("clientSort", JSON.stringify(sort));
    switch (sort.active) {
      case "name": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "name";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.getSenders();
        break;
      }
      case "email": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "email";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.getSenders();
        break;
      }
      case "contractEndDate": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "contractEndDate";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.getSenders();
        break;
      }
      default: {
        break;
      }
    }
  }

  getSenders() {
    this.loading = true;
    this.adminService.getSendersPaginated(this.pageable).subscribe(
      (response) => {
        this.loading = false;
        this.totalElements = response.totalElements;
        if (response.list.length == 0) {
          this.emptyList = true;
        } else {
          this.emptyList = false;
        }
        this.dataSource = new MatTableDataSource<Sender>();
        // this.dataSource.sort = this.sort;
        // this.dataSource.sortingDataAccessor = (item, property) => {
        //   switch (property) {
        //     case 'name': {
        //       return item.name.toLowerCase();
        //     }
        //     case 'expiration-date': {
        //       return parseISOString(item.contractEndDate);
        //     }
        //     default: {
        //       return item[property];
        //     }
        //   }
        // };
        this.dataSource.data = response.list;
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista dei Senders",
          err
        );
      }
    );
  }

  /** Ritorna lo stato del contratto.
   * 0 : tutto ok
   * 1 : contratto in scadenza  (a meno di 30 giorni dalla)
   * 2 : contratto scaduto
   */
  getContractStatus(sender): number {
    const date = new Date(sender.contractEndDate);
    const result = Math.floor(
      date.getTime() / 1000 - new Date().getTime() / 1000
    );
    if (result > 100 && result < 2600000) {
      // 2600000 sono i secondi i 30 giorni circa
      return 1;
    } else if (result <= 100) {
      return 2;
    } else {
      return 0;
    }
  }

  onSenderDetails(sender) {
    this.router.navigate([sender.id], { relativeTo: this.route });
  }

  onSenderDelete(sender) {
    const dialogRef = this.dialog.open(DeleteClientComponent, {
      width: "450px",
      data: sender,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openNewSenderDialog() {
    let senderInsertRequest: SenderInsertRequest;
    const dialogRef = this.dialog.open(InsertClientComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const dialogRef2 = this.dialog.open(InsertClientLogoComponent);
        dialogRef2.afterClosed().subscribe((result2) => {
          if (result2) {
            senderInsertRequest = {
              sender: {
                id: null,
                username: result.name,
                name: result.name,
                lang: "IT",
                logo: result2.logo,
                areaCreator: 1,
                contractStatus: 0,
                contractEndDate: result.contractEndDate,
                descr: result.descr,
                email: result.email,
                chatEnabled: 0,
                contractStartDate: result.contractStartDate,
                descrOpt: result.descrOpt,
                url: result.url,
                firma: result.firma,
                createdDate: null,
                modifiedDate: null,
              },
              categories: [],
              // aree: [],
              // users: null
            };
            this.sub = true;
            this.adminService.insertSender(senderInsertRequest).subscribe(
              (res) => {
                this.sub = false;
                this.openSnackBar("Mittente inserito con successo.", "Chiudi");
                this.getSenders(); // Riottiene i Senders compreso il nuovo inserimento
              },
              (err) => {
                console.error("Errore nell'inserimento del Sender.", err);
                this.genericErrorModalService.open(
                  "Errore durante l'inserimento del Mittente",
                  err
                );
                this.sub = false;
              }
            );
          }
        });
      }
    });
  }

  onFilterClear() {
    this.filterValue = "";
  }

  onFiltering() {
    this.paginator.firstPage();
    this.pageable.filter.value = this.filterValue;
    sessionStorage.setItem("latestFilterValueClients", this.filterValue);
    this.pageable.pageable.pageNum = 0;
    // this.dataSource.filter = this.filterValue.trim().toLowerCase();
    this.getSenders();
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue.length == 0 || this.filterValue.length > 3) {
        this.paginator.firstPage();
        this.pageable.filter.value = this.filterValue;
        sessionStorage.setItem("latestFilterValueClients", this.filterValue);
        this.pageable.pageable.pageNum = 0;
        // this.dataSource.filter = this.filterValue.trim().toLowerCase();
        this.getSenders();
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }
}

function parseISOString(s) {
  const b = s.split(/\D+/);
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
}
